import Vue from 'vue'
import VueRouter from 'vue-router'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import dashboard from '../views/dashboard/index.vue'
import user from '../views/user/index.vue'
import menu from '../views/menu/index.vue'
import role from '../views/role/index.vue'
import record from '../views/record/index.vue'
import analysishospital from '../views/analysishospital/index.vue'
import devices from '../views/devices/index.vue'
import controlsettings from '../views/controlsettings/index.vue'
import controlcompares from '../views/controlcompares/index.vue'
import hospital from '../views/hospital/index.vue'
import analysisworks from '../views/analysisworks/index.vue'
import history from '../views/history/index.vue'
import addrecord from '../views/addrecord/index.vue'
import addinformation from '../views/addinformation/index.vue'
import addhospital from '../views/addhospital/index.vue'
import adddevices from '../views/adddevices/index.vue'
import addquality from '../views/addquality/index.vue'
import editquality from '../views/editquality/index.vue'
import editdevices from '../views/editdevices/index.vue'
import changepassword from '../views/userpassword/index.vue'
import pdfconent from '../views/pdfconent/index.vue'
import pdfconentcopy from '../views/pdfconentcopy/index.vue'
import report from '../views/ui/viewer.vue'
import usreport from '../views/usui/viewer.vue'
import reportenlarge from '../views/reportenlarge/viewer.vue'
import usvideo from '../views/usvideo/viewer.vue'
import template from '../views/template/index.vue'
import editTemplate from '../views/editTemplate/index.vue'
import mpr from '../views/mpr/viewer.vue'
import imagetext from '../views/imagetext/index.vue'
import ultrasonic from '../views/ultrasonic/index.vue'
import editimagetext from '../views/editimagetext/index.vue'
import lookimagetext from '../views/lookimagetext/index.vue'
import lookimagehistory from '../views/lookimagehistory/index.vue'
import lookimagetextcopy from '../views/lookimagetextcopy/index.vue'
import drag from '../views/drag/index.vue'
import loginByToken from '../views/redirect/loginByToken.vue'

Vue.use(Router)

const routes = [
  {
    path: '/loginByToken',
    component: loginByToken,
    name: 'token登录',
  },
  {
    path: '/',
    redirect: {
      name:'login'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/sys/changepassword',
    component: changepassword,
    name: '修改密码',
    // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/mpr',
  component: mpr,
  name: 'mpr渲染',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
  {
    path: '/historyRecord',
    component: pdfconent,
    name: '展示',
    // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/imageText',
  component: imagetext,
  name: '图文报告',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/ultrasonic',
  component: ultrasonic,
  name: '超声详情',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/editimageText',
  component: editimagetext,
  name: '编辑图文报告',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/lookImageHistory',
  component: lookimagehistory,
  name: '查看历史报告',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/lookImageText',
  component: lookimagetext,
  name: '查看图文报告',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/lookImageTextcopy',
  component: lookimagetextcopy,
  name: '查看图文报告',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
  {
    path: '/historyRecordcopy',
    component: pdfconentcopy,
    name: '展示',
    // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
  {
    path: '/report',
    component: report,
    name: 'imagereport',
    // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
  {
    path: '/usreport',
    component: usreport,
    name: 'imagereport',
    // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/reportenlarge',
  component: reportenlarge,
  name: 'reportenlarge',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/usvideo',
  component: usvideo,
  name: 'usvideo',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
  {
    path: '/addTemplate',
    component: template,
    name: '新增模版',
    // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
  {
    path: '/editTemplate',
    component: editTemplate,
    name: '编辑模版',
    // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
  {
    path: '/dashboard/index',
    component: dashboard,
    name:'dashboard',
    children: [
    {
      path: '/sys/user',
      component: user,
      name: '用户列表',
      meta: {
        keepAlive: true  // 需要缓存
        }
      // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
  },
    {
      path: '/sys/role',
      component: role,
      name: '角色列表',
      meta: {
        keepAlive: true  // 需要缓存
        }
      // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
  },
  {
    path: '/sys/menu',
    component: menu,
    name: '菜单列表',
    meta: {
      keepAlive: true  // 需要缓存
      }
    // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/study/record',
  component: record,
  name: '检查登记',
  meta:{keepAlive:true},
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/analysis/hospital',
  component: analysishospital,
  name: '医疗机构统计',
  meta: {
    keepAlive: true  // 需要缓存
    },
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/devices',
  component: devices,
  name: '设备管理',
  meta: {
    keepAlive: true  // 需要缓存
    }
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/study/quality-control-settings',
  component: controlsettings,
  name: '质控配置',
  meta: {
    keepAlive: true  // 需要缓存
    }
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/study/quality-control-compares',
  component: controlcompares,
  name: '质控列表',
  meta: {
    keepAlive: true  // 需要缓存
    }
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/hospital',
  component: hospital,
  name: '医院管理',
  meta:{keepAlive:true},
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/analysis/works',
  component: analysisworks,
  name: '工作量统计',
  meta: {
    keepAlive: true  // 需要缓存
    }
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/study/history',
  component: history,
  name: '检查记录',
  meta:{
    keepAlive:true // 需要缓存
},
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/study/record/add',
  component: addrecord,
  name: '检查登记',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/study/record/addinformation',
  component: addinformation,
  name: '新增检查登记',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/study/hospital/addhospital',
  component: addhospital,
  name: '新增医院',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/study/devices/add',
  component: adddevices,
  name: '新增设备',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/study/quality/add',
  component: addquality,
  name: '新增质控配置',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/study/devices/edit',
  component: editdevices,
  name: '编辑设备',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/study/quality/edit',
  component: editquality,
  name: '编辑质控配置',
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
{
  path: '/report/template',
  component: drag,
  name: '模版管理',
  meta: {
    keepAlive: false  // 需要缓存
    },
  // meta: { title: '首页', icon: 'dashboard', affix: true, noCache: false }
},
  ]
},
];

const router = new VueRouter({
  routes
});
const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js